export const navLinks = [
  { label: 'About', href: '#about' },
  { label: 'Divisions', href: '#divisions' },
  { label: 'Why Us', href: '#why-us' },
  { label: 'Our Story', href: '#our-story' },
  { label: 'Milestones', href: '#milestones' },
  { label: 'Leadership', href: '#leadership' },
  {
    label: 'College',
    href: 'https://www.sbcollegeofpharmacy.com/',
    external: true,
  },
  {
    label: 'School',
    href: 'https://www.google.com/search?q=sundaravel+matriculation+school&oq=&gs_lcrp=EgZjaHJvbWUqCQgAEEUYOxjCAzIJCAAQRRg7GMIDMgkIARBFGDsYwgMyCQgCEEUYOxjCAzIJCAMQRRg7GMIDMgkIBBBFGDsYwgMyCQgFEEUYOxjCAzIJCAYQRRg7GMIDMgkIBxBFGDsYwgPSAQoyNDA5NTBqMGo3qAIIsAIB8QWL1-WxJuMYg_EFi9flsSbjGIM&sourceid=chrome&source=chrome.ob&ie=UTF-8',
    external: true,
  },
];

export const heroStats = [
  { value: '1969', label: 'Year Founded' },
  { value: '500+', label: 'Employees' },
  { value: '12', label: 'Manufacturing Units' },
  { value: '55+', label: 'Years of Legacy' },
  { value: '8', label: 'Business Divisions' },
];

export const heroSlides = [
  {
    badge: 'India’s No.1 Safety Match Legacy',
    heading: ['Every Spark', 'Tells A Story', 'Of Trust'],
    accentLine: 1,
    text: 'Born in Sivakasi, perfected over 55 years — our safety matches ignite over a billion homes across India, one flawless strike at a time.',
    accent: 'var(--orange)',
    image: '/images/hero/matches.jpg',
  },
  {
    badge: 'Licensed Fireworks Manufacturing',
    heading: ['Igniting Festivals,', 'Illuminating', 'Celebrations'],
    accentLine: 1,
    text: 'Engineered for brilliance, built for safety — our fireworks light up India’s biggest celebrations, festival after festival.',
    accent: 'var(--orange-dark)',
    image: '/images/divisions/sparkler-light.jpg',
  },
  {
    badge: 'In-House Offset Printing Division',
    heading: ['Precision Print,', 'Powering Every', 'Product We Make'],
    accentLine: 1,
    text: 'German-technology offset printing machines deliver flawless labels, packaging, and commercial print — vertically integrated for speed, consistency, and quality.',
    accent: 'var(--tag-blue)',
    image: '/images/hero/Modern Offset Printing Machine.png',
  },
  {
    badge: 'School · College · Higher Education',
    heading: ['Educating Minds,', 'Empowering', 'Futures'],
    accentLine: 1,
    text: 'From our matriculation school to our accredited pharmacy college, we build knowledge, discipline, and academic excellence at every stage of learning.',
    accent: 'linear-gradient(100deg, #ff6fb0 0%, #d94f9c 50%, #b23a8f 100%)',
    image: '/images/hero/Education 2.png',
  },
];

export const legacyFeatures = [
  { title: 'Match Manufacturing', desc: '12 units producing millions of safety matches daily' },
  { title: 'Fireworks Factory', desc: 'Licensed production of celebration fireworks' },
  { title: 'Hariram Chemicals', desc: 'Industrial chemical manufacturing division' },
  { title: 'Education Wing', desc: '1 college · 1 school · hundreds of graduates' },
];

// Drop each division's photo into public/images/divisions/ using <slug>.jpg
// (e.g. safety-matches.jpg). Falls back to a placeholder if the file isn't there yet.
export const divisions = [
  {
    number: '01',
    slug: 'safety-matches',
    icon: 'match',
    color: 'var(--tag-orange)',
    tag: '12 Production Units',
    title: 'Safety Matches',
    desc: 'Our flagship — precision-crafted safety matches produced across 12 state-of-the-art units. Trusted by millions of Indian households since 1969.',
    highlights: [
      'We manufacture more than 1 billion (1,000,000,000) match boxes a year',
      'We have touched more than 50,000 lives through direct or indirect employment in the past 50 years',
      'Keeping all match sticks we produce in a year, we could go around the circumference of the earth 45 times',
      'We have strictly followed the "Make in India" policy since 1969',
      'We have touched millions of lives and lit up billions of homes with our quality products for over 50 years',
    ],
  },
  {
    number: '02',
    slug: 'fireworks',
    icon: 'firework',
    color: 'var(--tag-yellow)',
    tag: 'Celebrations Illuminated',
    title: 'Fireworks',
    desc: 'A fully licensed fireworks facility producing celebration crackers and aerial display fireworks — engineered for maximum brilliance and safety.',
  },
  {
    number: '03',
    slug: 'chemicals',
    icon: 'flask',
    color: 'var(--tag-green)',
    tag: 'Chemical Industry',
    title: 'Chemicals',
    desc: 'High-quality industrial compounds and specialty chemicals from Hariram Chemicals, supplying our internal manufacturing ecosystem and external industrial clients.',
  },
  {
    number: '04',
    slug: 'printing',
    icon: 'printer',
    color: 'var(--tag-blue)',
    tag: 'Labels · Packaging · Print',
    title: 'Printing',
    desc: 'In-house printing facility delivering precision packaging, match box labels, and commercial print across offset and flexographic processes.',
  },
  {
    number: '05',
    slug: 'logistics',
    icon: 'truck',
    color: 'var(--tag-pink)',
    tag: 'Supply Chain · Transport',
    title: 'Logistics',
    desc: 'An in-house fleet and warehousing network moving raw materials and finished goods across every unit — and out to markets nationwide, on schedule.',
  },
  {
    number: '06',
    slug: 'plantation',
    icon: 'plant',
    color: 'var(--tag-teal)',
    tag: 'Agriculture · Raw Materials',
    title: 'Plantation',
    desc: 'Company-managed plantations supplying timber and raw materials that feed directly into match and packaging production — closing the loop from farm to factory.',
  },
  {
    number: '07',
    slug: 'pharmacy-college',
    icon: 'pharmacy',
    color: 'var(--tag-purple)',
    tag: 'Higher Education',
    title: 'Pharmacy College',
    desc: 'Accredited B.Pharm and D.Pharm programmes backed by modern labs, dedicated faculty, and strong industry placement records.',
  },
  {
    number: '08',
    slug: 'school',
    icon: 'school',
    color: 'var(--tag-brown)',
    tag: 'School Education',
    title: 'Sundaravel Matriculation Higher Secondary School',
    desc: 'Empowering young minds with excellence in academics, character building, and holistic development. We nurture confident, compassionate, and competent individuals through innovative teaching methods, experienced faculty, and a commitment to helping every child reach their full potential.',
  },
];

export const whyUsIntro = {
  eyebrow: 'Why Sundaravel Group',
  heading: ['Every match we make, we make ', 'ourselves', ' — start to finish.'],
  subtext:
    'Our match stick has a special chemical formulation which ensures reliable flame performance irrespective of extreme weather conditions.',
};

const vertIntegration =
  'Sundaravel group has exercised complete vertical integration of Match industry. The entire value chain of match making is managed in-house, right from procurement of raw materials to timely delivery of finished goods.';

export const valueChain = [
  {
    number: '01',
    title: 'Procurement',
    desc: vertIntegration,
  },
  {
    number: '02',
    title: 'Production',
    desc: 'Fully automatic production technology ensures top quality and consistency. Our 12 manufacturing units operate under strict quality control at every stage, from raw material handling to final packing. This discipline lets us meet growing demand without ever compromising on safety or precision.',
  },
  {
    number: '03',
    title: 'Printing',
    desc: 'German technology offset printing machines ensure precision accuracy of your design on match labels. Our in-house printing division handles everything from label design to high-speed production, removing dependency on external vendors. This vertical integration keeps turnaround times fast and print quality consistent across every batch.',
  },
  {
    number: '04',
    title: 'Distribution',
    desc: 'We have established a strong and deep distribution network into the FMCG market of India including rural areas. Our logistics team ensures products reach retailers and wholesalers on schedule, even in the most remote regions. This extensive reach has been a cornerstone of our five-decade relationship with customers across India.',
  },
  {
    number: '05',
    title: 'Delivery',
    desc: vertIntegration,
  },
];

export const milestones = [
  { year: '1969', text: 'Sundaravel Group founded with one match box unit in Sivakasi' },
  { year: '1974', text: 'Fireworks Factory licensed and commissioned' },
  { year: '1978', text: 'Expanded to 4 manufacturing units · 200 employees' },
  { year: '1987', text: 'Hariram Chemicals established · Chemical division launched' },
  { year: '1988', text: 'Sankaralingam Bhuvaneshwari College of Pharmacy inaugurated · Higher education wing established' },
  { year: '1999', text: 'Sundaravel School opened — 500 students from day one' },
  { year: '2018', text: 'Printing Division modernised · ISO quality certification achieved' },
];

export const leadershipSpeaks = {
  mission:
    'To delight our Customers, stakeholders & employees by manufacturing high quality matches at competitive prices and provide value for money experience at every touch point. We attain this by adhering to industry best practices in quality and safety standards.',
  vision:
    'The vision of Sundaravel Group is to be a premier manufacturer of quality matches that continue to enlighten billions of homes and lives across the globe.',
};

export const coreValues = [
  {
    title: 'Our Vision',
    desc: leadershipSpeaks.vision,
  },
  {
    title: 'Our Mission',
    desc: leadershipSpeaks.mission,
  },
  {
    title: 'Commitment',
    desc: "We commit to every person, entity or organisation associated with us to honour our deliverables by adhering to industry benchmarked practices. We ensure fair benefit to every stakeholder working with us, irrespective of market conditions, to maintain stable business relationships.",
  },
  {
    title: 'Integrity',
    desc: 'We believe true success is built on integrity. By embracing honesty, transparency, and accountability in every decision, we create lasting trust and meaningful relationships with our people, customers, and partners.',
  },
  {
    title: 'Contribution to Society',
    desc: 'Sundaravel Group believes any accomplishment is definitely due to the equal contribution of the society that supports the business to thrive.',
  },
];

// Drop each person's photo into public/images/leadership/ using the filename below.
// Square images (roughly 500x500) work best.
export const leadershipTeam = [
  {
    photo: '/images/leadership/Founder%201.png',
    initials: 'F',
    name: 'S. SANKARALINGA NADAR',
    since: 'Est. 1969',
    role: 'Founder',
    color: 'var(--tag-orange)',
    quote: '',
  },
  {
    photo: '/images/leadership/Chairman%201.png',
    initials: 'C',
    name: 'S. SRIRAM ASHOK',
    since: '',
    role: 'Chairman',
    color: 'var(--tag-yellow)',
    quote: '',
  },
  {
    photo: '/images/leadership/Managing%20Director1.png',
    initials: 'MD',
    name: 'S. HARIRAM SUNDARAVEL',
    since: 'Since 1998',
    role: 'Managing Director',
    color: 'var(--tag-green)',
    quote: '',
  },
];

export const employeeBenefits = [
  {
    title: 'Free Education',
    desc: "We understand that an employee's family is just as important as the employee themselves. That's why we offer free education for employees' children, helping ease the financial burden of raising a family and giving our employees peace of mind about their children's future.",
  },
  {
    title: 'Medical Insurance',
    desc: 'We are committed to the health and wellbeing of our employees and their families. As part of our comprehensive benefits package, the company covers 100% of the medical insurance premium for all eligible full-time employees.',
  },
  {
    title: 'Pension Benefits',
    desc: "We believe in supporting our employees not just today, but well into their future. That's why we provide 100% company-funded pension benefits for all eligible employees.",
  },
];

export const contactInfo = [
  {
    label: 'Head Office',
    value: '69, A. S. K, Thangaiahnadar Road, Sivakasi 626189',
    // Plain coordinates, not a business-name search — a named-place query
    // makes Google's embed auto-open a business-listing info card (rating,
    // photos, share/directions icons) that can't be styled or removed
    // since it renders inside Google's own cross-origin iframe. A
    // coordinate query just drops a plain pin instead. These are Google's
    // own resolved coordinates for "Sundaravel Match Industries (P) Ltd".
    lat: 9.4482211,
    lng: 77.8080216,
  },
  { label: 'Email', value: 'enquiry@sundaravelgroup.com' },
  { label: 'Hours', value: 'Mon – Sat: 9:00 AM – 6:00 PM IST' },
];

export const footerNav = [
  { label: 'About', href: '#about' },
  { label: 'Divisions', href: '#divisions' },
  { label: 'Why Us', href: '#why-us' },
  { label: 'Milestones', href: '#milestones' },
  { label: 'Leadership', href: '#leadership' },
  { label: 'Contact', href: '#contact' },
];

export const footerDivisions = [
  'Safety Matches',
  'Fireworks',
  'Chemicals',
  'Printing',
  'Logistics',
  'Plantation',
  'Pharmacy College',
  'Sundaravel School',
];
